<template>
    <div>
        <h1>Select retailers</h1>

    </div>
</template>

<script>

export default {
    name: "select-retailers",
    data: function () {
        return {
            integrators: [],
        };
    },
    mounted() {
        this.getIntegrators();
    },
    methods: {
        getIntegrators() {
            this.integrators = [
                {
                    id: 1,
                    name: 'Integrator 1',
                    sellers: [
                        {
                            id: 1,
                            name: 'Seller 1',
                        },
                        {
                            id: 2,
                            name: 'Seller 2',
                        },
                        {
                            id: 3,
                            name: 'Seller 3',
                        }
                    ]
                },
                {
                    id: 2,
                    name: 'Integrator 2',
                    sellers: [
                        {
                            id: 4,
                            name: 'Seller 4',
                        },
                        {
                            id: 5,
                            name: 'Seller 5',
                        }
                    ]
                },
                {
                    id: 3,
                    name: 'Integrator 3',
                },
            ];
        },
    }
}

</script>


<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// SelectRetailersComponent.vue?66b76499